import script from "./ArcheryShooting.vue?vue&type=script&setup=true&lang=js"
export * from "./ArcheryShooting.vue?vue&type=script&setup=true&lang=js"

import "./ArcheryShooting.vue?vue&type=style&index=0&id=f0477be8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0477be8"]])

export default __exports__